// Put your application javascript here
(function () {
  var MINTT_BLOCK_SELECTOR = '[id*="mintt_tiktok_feed"]';
  var SECTION_FALLBACK_SELECTOR = '[id$="__1775738701c1062888"]';
  var CARD_PATTERNS = [
    "fg-mintt-card--tall",
    "fg-mintt-card--landscape",
    "fg-mintt-card--square",
    "fg-mintt-card--portrait",
    "fg-mintt-card--medium",
    "fg-mintt-card--tower",
    "fg-mintt-card--soft-square",
    "fg-mintt-card--regular"
  ];

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }

    callback();
  }

  function debounce(fn, wait) {
    var timeoutId;

    return function () {
      var args = arguments;
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function getMinttSections() {
    var sections = [];

    document.querySelectorAll(MINTT_BLOCK_SELECTOR).forEach(function (block) {
      var section = block.closest(".shopify-section");
      if (section && sections.indexOf(section) === -1) {
        sections.push(section);
      }
    });

    if (!sections.length) {
      var fallback = document.querySelector(SECTION_FALLBACK_SELECTOR);
      if (fallback) {
        sections.push(fallback);
      }
    }

    return sections;
  }

  function getDepth(section, node) {
    var depth = 0;
    var current = node;

    while (current && current !== section) {
      depth += 1;
      current = current.parentElement;
    }

    return depth;
  }

  function getInteractiveCards(section) {
    var nodes = Array.from(section.querySelectorAll("a, button, [role='button']"));

    return nodes.filter(function (node) {
      var href = node.getAttribute("href") || "";
      var hasMedia = Boolean(node.querySelector("img, picture, video, canvas, iframe"));
      var looksLikeTikTokLink =
        node.tagName !== "A" ||
        href.indexOf("tiktok.com") !== -1 ||
        href.indexOf("vm.tiktok.com") !== -1 ||
        href.indexOf("/video/") !== -1;

      return hasMedia && looksLikeTikTokLink;
    });
  }

  function resolveFeedNodes(section) {
    var cards = getInteractiveCards(section);

    if (cards.length < 4) {
      return null;
    }

    var records = new Map();

    cards.forEach(function (card) {
      var ancestor = card.parentElement;

      while (ancestor && ancestor !== section) {
        var record = records.get(ancestor);

        if (!record) {
          record = {
            node: ancestor,
            children: new Set(),
            depth: getDepth(section, ancestor)
          };
          records.set(ancestor, record);
        }

        var directChild = card;
        while (directChild.parentElement && directChild.parentElement !== ancestor) {
          directChild = directChild.parentElement;
        }

        if (directChild !== ancestor) {
          record.children.add(directChild);
        }

        ancestor = ancestor.parentElement;
      }
    });

    var bestRecord = null;

    records.forEach(function (record) {
      if (record.children.size < 4) {
        return;
      }

      if (
        !bestRecord ||
        record.depth > bestRecord.depth ||
        (record.depth === bestRecord.depth && record.children.size > bestRecord.children.size)
      ) {
        bestRecord = record;
      }
    });

    if (!bestRecord) {
      return null;
    }

    return {
      container: bestRecord.node,
      items: Array.from(bestRecord.children).filter(function (item) {
        return item.parentElement === bestRecord.node;
      })
    };
  }

  function applyPatternClasses(items) {
    items.forEach(function (item, index) {
      item.classList.add("fg-mintt-card");
      CARD_PATTERNS.forEach(function (pattern) {
        item.classList.remove(pattern);
      });
      item.classList.add(CARD_PATTERNS[index % CARD_PATTERNS.length]);
    });
  }

  function measureCardSpans(container, items) {
    items.forEach(function (item) {
      item.style.gridRowEnd = "";
    });

    var styles = window.getComputedStyle(container);
    var rowSize = parseFloat(styles.gridAutoRows) || 10;
    var gap = parseFloat(styles.rowGap) || 0;

    var heights = items.map(function (item) {
      return item.getBoundingClientRect().height;
    });

    heights.forEach(function (height, i) {
      var span = Math.max(1, Math.ceil((height + gap) / (rowSize + gap)));
      items[i].style.gridRowEnd = "span " + span;
    });
  }

  function syncSection(section) {
    var feed = resolveFeedNodes(section);

    if (!feed || feed.items.length < 4) {
      return false;
    }

    section.classList.add("fg-mintt-feed-section");
    feed.container.classList.add("fg-mintt-masonry");
    applyPatternClasses(feed.items);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        measureCardSpans(feed.container, feed.items);
      });
    });

    return true;
  }

  function observeSection(section) {
    if (section.__fgMinttObserver) {
      return;
    }

    var rerender = debounce(function () {
      syncSection(section);
    }, 80);

    var observer = new MutationObserver(function () {
      rerender();
    });

    observer.observe(section, { childList: true, subtree: true });
    section.__fgMinttObserver = observer;
  }

  onReady(function () {
    var bodyObserver;

    function trySyncAll() {
      var sections = getMinttSections();
      sections.forEach(function (section) {
        observeSection(section);
      });
      var allSynced = sections.length > 0 && sections.every(function (section) {
        return syncSection(section);
      });
      if (allSynced && bodyObserver) {
        bodyObserver.disconnect();
        bodyObserver = null;
      }
    }

    var syncAll = debounce(trySyncAll, 60);

    trySyncAll();

    bodyObserver = new MutationObserver(syncAll);
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      if (bodyObserver) {
        bodyObserver.disconnect();
        bodyObserver = null;
      }
    }, 8000);

    window.addEventListener("resize", debounce(trySyncAll, 120));
    document.addEventListener("shopify:section:load", trySyncAll);
    document.addEventListener("shopify:section:reorder", trySyncAll);
  });
})();
